export const REGISTRY = 'REGISTRY'
export const REGISTRYBILLING = 'REGISTRYBILLING'